/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint128",
                name: "addAmount",
                type: "uint128",
            },
            {
                indexed: false,
                internalType: "uint128",
                name: "acquireAmount",
                type: "uint128",
            },
            {
                indexed: true,
                internalType: "int24",
                name: "point",
                type: "int24",
            },
            {
                indexed: false,
                internalType: "uint128",
                name: "claimSold",
                type: "uint128",
            },
            {
                indexed: false,
                internalType: "uint128",
                name: "claimEarn",
                type: "uint128",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "sellXEarnY",
                type: "bool",
            },
        ],
        name: "AddLimitOrder",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "int24",
                name: "leftPoint",
                type: "int24",
            },
            {
                indexed: true,
                internalType: "int24",
                name: "rightPoint",
                type: "int24",
            },
            {
                indexed: false,
                internalType: "uint128",
                name: "liquidity",
                type: "uint128",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amountX",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amountY",
                type: "uint256",
            },
        ],
        name: "Burn",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                indexed: true,
                internalType: "int24",
                name: "point",
                type: "int24",
            },
            {
                indexed: false,
                internalType: "uint128",
                name: "collectDec",
                type: "uint128",
            },
            {
                indexed: false,
                internalType: "uint128",
                name: "collectEarn",
                type: "uint128",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "sellXEarnY",
                type: "bool",
            },
        ],
        name: "CollectLimitOrder",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                indexed: true,
                internalType: "int24",
                name: "leftPoint",
                type: "int24",
            },
            {
                indexed: true,
                internalType: "int24",
                name: "rightPoint",
                type: "int24",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amountX",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amountY",
                type: "uint256",
            },
        ],
        name: "CollectLiquidity",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint128",
                name: "decreaseAmount",
                type: "uint128",
            },
            {
                indexed: true,
                internalType: "int24",
                name: "point",
                type: "int24",
            },
            {
                indexed: false,
                internalType: "uint128",
                name: "claimSold",
                type: "uint128",
            },
            {
                indexed: false,
                internalType: "uint128",
                name: "claimEarn",
                type: "uint128",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "sellXEarnY",
                type: "bool",
            },
        ],
        name: "DecLimitOrder",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amountX",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amountY",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "paidX",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "paidY",
                type: "uint256",
            },
        ],
        name: "Flash",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "int24",
                name: "leftPoint",
                type: "int24",
            },
            {
                indexed: true,
                internalType: "int24",
                name: "rightPoint",
                type: "int24",
            },
            {
                indexed: false,
                internalType: "uint128",
                name: "liquidity",
                type: "uint128",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amountX",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amountY",
                type: "uint256",
            },
        ],
        name: "Mint",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "tokenX",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "tokenY",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint24",
                name: "fee",
                type: "uint24",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "sellXEarnY",
                type: "bool",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amountX",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amountY",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "int24",
                name: "currentPoint",
                type: "int24",
            },
        ],
        name: "Swap",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "int24",
                name: "point",
                type: "int24",
            },
            {
                internalType: "uint128",
                name: "amountX",
                type: "uint128",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "addLimOrderWithX",
        outputs: [
            {
                internalType: "uint128",
                name: "orderX",
                type: "uint128",
            },
            {
                internalType: "uint128",
                name: "acquireY",
                type: "uint128",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "int24",
                name: "point",
                type: "int24",
            },
            {
                internalType: "uint128",
                name: "amountY",
                type: "uint128",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "addLimOrderWithY",
        outputs: [
            {
                internalType: "uint128",
                name: "orderY",
                type: "uint128",
            },
            {
                internalType: "uint128",
                name: "acquireX",
                type: "uint128",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "int24",
                name: "point",
                type: "int24",
            },
            {
                internalType: "uint128",
                name: "assignX",
                type: "uint128",
            },
            {
                internalType: "bool",
                name: "fromLegacy",
                type: "bool",
            },
        ],
        name: "assignLimOrderEarnX",
        outputs: [
            {
                internalType: "uint128",
                name: "actualAssignX",
                type: "uint128",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "int24",
                name: "point",
                type: "int24",
            },
            {
                internalType: "uint128",
                name: "assignY",
                type: "uint128",
            },
            {
                internalType: "bool",
                name: "fromLegacy",
                type: "bool",
            },
        ],
        name: "assignLimOrderEarnY",
        outputs: [
            {
                internalType: "uint128",
                name: "actualAssignY",
                type: "uint128",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "int24",
                name: "leftPt",
                type: "int24",
            },
            {
                internalType: "int24",
                name: "rightPt",
                type: "int24",
            },
            {
                internalType: "uint128",
                name: "liquidDelta",
                type: "uint128",
            },
        ],
        name: "burn",
        outputs: [
            {
                internalType: "uint256",
                name: "amountX",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "amountY",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "int24",
                name: "leftPt",
                type: "int24",
            },
            {
                internalType: "int24",
                name: "rightPt",
                type: "int24",
            },
            {
                internalType: "uint256",
                name: "amountXLim",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "amountYLim",
                type: "uint256",
            },
        ],
        name: "collect",
        outputs: [
            {
                internalType: "uint256",
                name: "actualAmountX",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "actualAmountY",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "collectFeeCharged",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "int24",
                name: "point",
                type: "int24",
            },
            {
                internalType: "uint128",
                name: "collectDec",
                type: "uint128",
            },
            {
                internalType: "uint128",
                name: "collectEarn",
                type: "uint128",
            },
            {
                internalType: "bool",
                name: "isEarnY",
                type: "bool",
            },
        ],
        name: "collectLimOrder",
        outputs: [
            {
                internalType: "uint128",
                name: "actualCollectDec",
                type: "uint128",
            },
            {
                internalType: "uint128",
                name: "actualCollectEarn",
                type: "uint128",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "int24",
                name: "point",
                type: "int24",
            },
            {
                internalType: "uint128",
                name: "deltaX",
                type: "uint128",
            },
        ],
        name: "decLimOrderWithX",
        outputs: [
            {
                internalType: "uint128",
                name: "actualDeltaX",
                type: "uint128",
            },
            {
                internalType: "uint256",
                name: "legacyAccEarn",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "int24",
                name: "point",
                type: "int24",
            },
            {
                internalType: "uint128",
                name: "deltaY",
                type: "uint128",
            },
        ],
        name: "decLimOrderWithY",
        outputs: [
            {
                internalType: "uint128",
                name: "actualDeltaY",
                type: "uint128",
            },
            {
                internalType: "uint256",
                name: "legacyAccEarn",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint16",
                name: "newNextQueueLen",
                type: "uint16",
            },
        ],
        name: "expandObservationQueue",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "factory",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "fee",
        outputs: [
            {
                internalType: "uint24",
                name: "",
                type: "uint24",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "feeChargePercent",
        outputs: [
            {
                internalType: "uint24",
                name: "",
                type: "uint24",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "feeScaleX_128",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "feeScaleY_128",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amountX",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "amountY",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "flash",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "leftMostPt",
        outputs: [
            {
                internalType: "int24",
                name: "",
                type: "int24",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "int24",
                name: "",
                type: "int24",
            },
        ],
        name: "limitOrderData",
        outputs: [
            {
                internalType: "uint128",
                name: "sellingX",
                type: "uint128",
            },
            {
                internalType: "uint128",
                name: "earnY",
                type: "uint128",
            },
            {
                internalType: "uint256",
                name: "accEarnY",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "legacyAccEarnY",
                type: "uint256",
            },
            {
                internalType: "uint128",
                name: "legacyEarnY",
                type: "uint128",
            },
            {
                internalType: "uint128",
                name: "sellingY",
                type: "uint128",
            },
            {
                internalType: "uint128",
                name: "earnX",
                type: "uint128",
            },
            {
                internalType: "uint128",
                name: "legacyEarnX",
                type: "uint128",
            },
            {
                internalType: "uint256",
                name: "accEarnX",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "legacyAccEarnX",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "int24",
                name: "leftPoint",
                type: "int24",
            },
            {
                internalType: "int24",
                name: "rightPoint",
                type: "int24",
            },
        ],
        name: "limitOrderSnapshot",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint128",
                        name: "sellingX",
                        type: "uint128",
                    },
                    {
                        internalType: "uint128",
                        name: "earnY",
                        type: "uint128",
                    },
                    {
                        internalType: "uint256",
                        name: "accEarnY",
                        type: "uint256",
                    },
                    {
                        internalType: "uint128",
                        name: "sellingY",
                        type: "uint128",
                    },
                    {
                        internalType: "uint128",
                        name: "earnX",
                        type: "uint128",
                    },
                    {
                        internalType: "uint256",
                        name: "accEarnX",
                        type: "uint256",
                    },
                ],
                internalType: "struct IiZiSwapPool.LimitOrderStruct[]",
                name: "limitOrders",
                type: "tuple[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        name: "liquidity",
        outputs: [
            {
                internalType: "uint128",
                name: "liquidity",
                type: "uint128",
            },
            {
                internalType: "uint256",
                name: "lastFeeScaleX_128",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "lastFeeScaleY_128",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "tokenOwedX",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "tokenOwedY",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "int24",
                name: "leftPoint",
                type: "int24",
            },
            {
                internalType: "int24",
                name: "rightPoint",
                type: "int24",
            },
        ],
        name: "liquiditySnapshot",
        outputs: [
            {
                internalType: "int128[]",
                name: "deltaLiquidities",
                type: "int128[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "maxLiquidPt",
        outputs: [
            {
                internalType: "uint128",
                name: "",
                type: "uint128",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "int24",
                name: "leftPt",
                type: "int24",
            },
            {
                internalType: "int24",
                name: "rightPt",
                type: "int24",
            },
            {
                internalType: "uint128",
                name: "liquidDelta",
                type: "uint128",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "mint",
        outputs: [
            {
                internalType: "uint256",
                name: "amountX",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "amountY",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint24",
                name: "newFeeChargePercent",
                type: "uint24",
            },
        ],
        name: "modifyFeeChargePercent",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "observations",
        outputs: [
            {
                internalType: "uint32",
                name: "timestamp",
                type: "uint32",
            },
            {
                internalType: "int56",
                name: "accPoint",
                type: "int56",
            },
            {
                internalType: "bool",
                name: "init",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32[]",
                name: "secondsAgos",
                type: "uint32[]",
            },
        ],
        name: "observe",
        outputs: [
            {
                internalType: "int56[]",
                name: "accPoints",
                type: "int56[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "int24",
                name: "",
                type: "int24",
            },
        ],
        name: "orderOrEndpoint",
        outputs: [
            {
                internalType: "int24",
                name: "",
                type: "int24",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "int16",
                name: "",
                type: "int16",
            },
        ],
        name: "pointBitmap",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pointDelta",
        outputs: [
            {
                internalType: "int24",
                name: "",
                type: "int24",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "int24",
                name: "",
                type: "int24",
            },
        ],
        name: "points",
        outputs: [
            {
                internalType: "uint128",
                name: "liquidSum",
                type: "uint128",
            },
            {
                internalType: "int128",
                name: "liquidDelta",
                type: "int128",
            },
            {
                internalType: "uint256",
                name: "accFeeXOut_128",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "accFeeYOut_128",
                type: "uint256",
            },
            {
                internalType: "bool",
                name: "isEndpt",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "rightMostPt",
        outputs: [
            {
                internalType: "int24",
                name: "",
                type: "int24",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "sqrtRate_96",
        outputs: [
            {
                internalType: "uint160",
                name: "",
                type: "uint160",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "state",
        outputs: [
            {
                internalType: "uint160",
                name: "sqrtPrice_96",
                type: "uint160",
            },
            {
                internalType: "int24",
                name: "currentPoint",
                type: "int24",
            },
            {
                internalType: "uint16",
                name: "observationCurrentIndex",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "observationQueueLen",
                type: "uint16",
            },
            {
                internalType: "uint16",
                name: "observationNextQueueLen",
                type: "uint16",
            },
            {
                internalType: "bool",
                name: "locked",
                type: "bool",
            },
            {
                internalType: "uint128",
                name: "liquidity",
                type: "uint128",
            },
            {
                internalType: "uint128",
                name: "liquidityX",
                type: "uint128",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint128",
                name: "amount",
                type: "uint128",
            },
            {
                internalType: "int24",
                name: "lowPt",
                type: "int24",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "swapX2Y",
        outputs: [
            {
                internalType: "uint256",
                name: "amountX",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "amountY",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint128",
                name: "desireY",
                type: "uint128",
            },
            {
                internalType: "int24",
                name: "lowPt",
                type: "int24",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "swapX2YDesireY",
        outputs: [
            {
                internalType: "uint256",
                name: "amountX",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "amountY",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint128",
                name: "amount",
                type: "uint128",
            },
            {
                internalType: "int24",
                name: "highPt",
                type: "int24",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "swapY2X",
        outputs: [
            {
                internalType: "uint256",
                name: "amountX",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "amountY",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint128",
                name: "desireX",
                type: "uint128",
            },
            {
                internalType: "int24",
                name: "highPt",
                type: "int24",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "swapY2XDesireX",
        outputs: [
            {
                internalType: "uint256",
                name: "amountX",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "amountY",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "tokenX",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "tokenY",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalFeeXCharged",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalFeeYCharged",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        name: "userEarnX",
        outputs: [
            {
                internalType: "uint256",
                name: "lastAccEarn",
                type: "uint256",
            },
            {
                internalType: "uint128",
                name: "sellingRemain",
                type: "uint128",
            },
            {
                internalType: "uint128",
                name: "sellingDec",
                type: "uint128",
            },
            {
                internalType: "uint128",
                name: "earn",
                type: "uint128",
            },
            {
                internalType: "uint128",
                name: "legacyEarn",
                type: "uint128",
            },
            {
                internalType: "uint128",
                name: "earnAssign",
                type: "uint128",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        name: "userEarnY",
        outputs: [
            {
                internalType: "uint256",
                name: "lastAccEarn",
                type: "uint256",
            },
            {
                internalType: "uint128",
                name: "sellingRemain",
                type: "uint128",
            },
            {
                internalType: "uint128",
                name: "sellingDec",
                type: "uint128",
            },
            {
                internalType: "uint128",
                name: "earn",
                type: "uint128",
            },
            {
                internalType: "uint128",
                name: "legacyEarn",
                type: "uint128",
            },
            {
                internalType: "uint128",
                name: "earnAssign",
                type: "uint128",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class IZiSwapPool__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
IZiSwapPool__factory.bytecode = _bytecode;
IZiSwapPool__factory.abi = _abi;
